import { Tooltip } from "@mui/material";
import DotIcon from "@entrilia/shared/icons/DotIcon";
import type { PageStatus } from "../../hooks/useImpersonationPageStatus";

interface Props {
  status: PageStatus;
}

const PageStatusIndicator = ({ status }: Props) => {
  const title = status === "live" ? "This page is Live" : "This page is in Preview";

  return (
    <Tooltip arrow title={title}>
      <DotIcon aria-label={title} color={status === "live" ? "success" : "info"} sx={{ height: 12, width: 12 }} />
    </Tooltip>
  );
};

export default PageStatusIndicator;
